import { isNil } from 'lodash'
import { User } from '../models/userModel'
import { Currency } from '../models/moneyModel'
import { Company, PaymentDestination } from '../models/companyModel'
import { LogicalFilter, LogicalOperator } from '@hello-aria/query-string'
import { ComparisonFilterInput, NestedLogicalFilterInput } from '@hello-aria/query-string/dist/stringify'

export const resolveBeneficiaryName = (user: Pick<User, 'businessName' | 'fullName' | 'email'> | undefined): string => {
    if (isNil(user)) return '-'
    if (user.businessName) return user.businessName
    if (user.fullName) return user.fullName
    return user.email
}

export const getPaymentDestinationsByCurrency = (
    paymentDestinations: User['paymentDestinations'],
    currency: Currency
): PaymentDestination | undefined => {
    if (isNil(paymentDestinations) || paymentDestinations.length === 0) return undefined

    if (currency === 'EUR') {
        return paymentDestinations.find((paymentDestination) => paymentDestination.type === 'BANK_ACCOUNT')
    } else if (currency === 'GBP') {
        return paymentDestinations.find(
            (paymentDestination) =>
                paymentDestination.type === 'BANK_ACCOUNT_SCAN' ||
                (paymentDestination.type === 'BANK_ACCOUNT' && paymentDestination.accountNumber.startsWith('GB'))
        )
    } else {
        return undefined
    }
}

export const shouldDisplayOnboardingOrKyc = (user: User | undefined, company: Company | undefined): boolean => {
    if (!isNil(user?.onboarding) || (company?.config.needsKyc && !isNil(user?.kyc))) {
        return true
    }
    return false
}

export interface ResolveUsersFilters {
    type: LogicalFilter['type']
    operator: LogicalOperator
    filters: (
        | ComparisonFilterInput
        | {
              type: LogicalFilter['type']
              operator: LogicalOperator
              filters: ComparisonFilterInput[]
          }
    )[]
}

export type ResolveUsersFiltersParams = {
    customFilters?: (ComparisonFilterInput | NestedLogicalFilterInput)[]
}

export const resolveUserFilters = ({ customFilters }: ResolveUsersFiltersParams): ResolveUsersFilters => {
    const filters: (ComparisonFilterInput | NestedLogicalFilterInput)[] = customFilters ?? []

    return {
        type: 'logical',
        operator: 'and',
        filters
    }
}
